module.exports = __webpack_public_path__ + "img/1.287da494.png";